<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-academy-register-form" style="background: #fff">

        <page-title :title="'Formularz rejestracji'" :back="true"></page-title>

        <slide-y-up-transition :duration="500" :delay="200">
            <div v-show="show" class="box-info text-center">Podaj swoje dane do rejestracji.</div>
        </slide-y-up-transition>

        <form-academy-register></form-academy-register>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';
    import FormAcademyRegister from '@/forms/FormAcademyRegister.vue';

    export default {
        name: 'AcademyRegister',
        components: { PageTitle, FormAcademyRegister },
        data() {
            return {
              show: false
            }
        },
        mounted(){
            this.show = true
        }
    }
</script>